import React, { useEffect, useRef } from 'react';
import QRCode from 'qrcode';

export default function QrCode({ value, size = 140, className = '' }) {
  const canvasRef = useRef();

  useEffect(() => {
    if (!value || !canvasRef.current) return;
    QRCode.toCanvas(canvasRef.current, value, {
      width: size,
      margin: 1,
      color: { dark: '#1a1a2e', light: '#ffffff' },
    });
  }, [value, size]);

  if (!value) return null;
  return <canvas ref={canvasRef} className={className} />;
}

// EPC GiroCode format for SEPA bank transfers
export function buildEpcQr({ iban, bic = '', holder, amount, reference }) {
  const lines = [
    'BCD',       // Service Tag
    '002',       // Version
    '1',         // Encoding: UTF-8
    'SCT',       // SEPA Credit Transfer
    bic,
    holder,
    iban,
    amount ? `EUR${parseFloat(amount).toFixed(2)}` : '',
    '',          // Purpose
    reference || '',
    '',          // Remittance info
  ];
  return lines.join('\n');
}
